import { useContext } from "react";
import { ProductContext, MountingContext } from "../../App";
import product_4300a from "../../images/configurationIcons/4300W-a.svg";
import product_4300b from "../../images/configurationIcons/4300W-b.svg";
import product_4300c from "../../images/configurationIcons/4300W-c.svg";
import { t } from "i18next";

const PRODUCT_4300A = "4300a";
const PRODUCT_4300B = "4300b";
const PRODUCT_4300C = "4300c";

function Configuration() {
  const { currentProduct, currentConfiguration, setCurrentConfiguration } = useContext(ProductContext);
  const {
    selectedWing,
    setTopMounting,
    setRightMounting,
    setBottomMounting,
    setLeftMounting,
  } = useContext(MountingContext);

  function handleCurrentWindowChange(event) {
    currentProduct.setCustom(event.target.id);
    setCurrentConfiguration(event.target.id);
    setTopMounting(currentProduct[selectedWing].top.visible);
    setBottomMounting(currentProduct[selectedWing].bottom.visible);

    if (currentConfiguration === '4300a') {
      if (selectedWing == 'wingRight')
        setRightMounting(currentProduct[selectedWing].right.visible);

      if (selectedWing == 'wingLeft')
        setLeftMounting(currentProduct[selectedWing].left.visible);
    }
  }

  return (
    <section className="panel-container__section">
      <h2 className="section__title">{t('config')}</h2>
      <div className="section__window-picker">
        <button>
          <img
            id={PRODUCT_4300A}
            className={`section__window ${currentConfiguration === PRODUCT_4300A ? "section__window--selected" : ""}`}
            src={product_4300a}
            alt=""
            onClick={handleCurrentWindowChange.bind(this)}
          />
        </button>
        <button>
          <img
            id={PRODUCT_4300B}
            className={`section__window ${currentConfiguration === PRODUCT_4300B ? "section__window--selected" : ""}`}
            src={product_4300b}
            alt=""
            onClick={handleCurrentWindowChange.bind(this)}
          />
        </button>
        <button>
          <img
            id={PRODUCT_4300C}
            className={`section__window ${currentConfiguration === PRODUCT_4300C ? "section__window--selected" : ""}`}
            src={product_4300c}
            alt=""
            onClick={handleCurrentWindowChange.bind(this)}
          />
        </button>
      </div>
    </section>
  );
}

export default Configuration;
